import React, { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

interface CellContentProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  titleClassName?: string
  contentClassName?: string
}

export const CellContent: FC<CellContentProps> = ({
  title,
  children,
  titleClassName,
  contentClassName,
  className,
  ...rest
}) => (
  <div
    className={cn('grid w-full min-w-0 grid-rows-[64px_auto] lg:grid-rows-[40px_minmax(32px,auto)]', className)}
    {...rest}
  >
    <p className={cn('text-neutral-dark ps-5 pt-4 pb-2 text-lg font-bold uppercase md:pb-2 lg:pb-0', titleClassName)}>
      {title}
    </p>
    <div className={contentClassName}>{children}</div>
  </div>
)
